// extracted by mini-css-extract-plugin
export default {"tabsContainer":"AccessRequests_tabsContainer__1i5Mx"};